export default __webpack_public_path__ + "static/media/Pistol_2.5cc2b27f.png";